<template>
    <footer class="section-block block-invert s-footer">
        <div class="container">
            <nav class="footer-nav text-center">
                <social-icons :sitesettings="sitedata.settings[0]" class="social-links-big mb-0"/>
                <ul class="list-inline mt-4 mb-4">
                    <li v-if="onepager" class="list-inline-item"><a class="nav-item nav-link scroll active" :href="urlprefix" v-scroll-to="'#top'">Home</a></li>
                    <li v-else class="list-inline-item"><a :class="{'active': $route.params.pageslug == null}" class="nav-item nav-link scroll" :href="urlprefix">Home</a></li>
                    <li class="list-inline-item" v-for="menuitem in menupages">
                        <a v-if="onepager" class="nav-item nav-link scroll" :href="urlprefix+menuitem.pageslug" v-scroll-to="'#'+menuitem.pageslug">{{ menuitem.pagetitle }}</a>
                        <a v-else class="nav-item nav-link" :class="{'active': $route.params.pageslug == menuitem.pageslug}" :href="urlprefix+menuitem.pageslug">{{ menuitem.pagetitle }}</a>
                    </li>
                </ul>
                <div>
                    <strong>Adres: </strong>
                    <span v-if="readonly" class="edited_content text-muted">
                        {{ sitedata.address }}
                    </span>
                    <inline-editor v-if="!readonly" :editable="sitedata.address" dbentry="address" element="normal"/>
                </div>
                <div class="copyright mt-5">
                <span class="ico material-icons text-muted">copyright</span> 2020</div>
            </nav>
        </div>
        <div v-if="!readonly || creatoreditor && userWebsiteId.includes(websiteid)" style="position: fixed; right: 40px; left: 40px;bottom: 40px; z-index: 1030;">
            <button class="btn btn-secondary" @click.prevent="toggleView()" style="background: rgba(0,0,0,0.6); margin-right: 10px;"><span v-if="!readonly">Toon resultaat</span><span v-if="readonly">Toon knoppen</span></button>
            <a class="btn btn-secondary" :href="'/creator/'+websiteid+'/settingspage'" style="background: rgba(0,0,0,0.6);">Website opties</a>
        </div>

        <div v-if="!sitedata.isactive">
            <div v-if="!readonly || creatoreditor && userWebsiteId.includes(websiteid)" style="position: fixed; right: 40px; bottom: 40px; z-index: 1030;">
                <a class="btn btn-success toggle-chat-box" @click.prevent="chatBox = true">Deze website kopen?</a>
                <div v-if="chatBox" style="position: absolute; width: 300px;right: 0; bottom: 100%; max-height: 500px; overflow: auto;" class="chat-box">
                    <form id="chat-form">
                        <div class="chat-block d-block">
                            <div class="chat-bubble chat-bubble--left">Hi, Wil je deze website kopen om meteen te gebruiken?</div>
                            <div class="btn-option" v-if="!iktwijfel"><button class="btn btn-primary" @click.prevent="ikwilwebsite = true, orderinfo.request = 'Wants to buy'">Ja, ik wil deze website!</button></div>
                            <div class="btn-option" v-if="!ikwilwebsite"><button class="btn btn-outline-primary" @click.prevent="iktwijfel = true, orderinfo.request = 'Wants info'" id="inforequest">Ik twijfel nog...</button></div>
                        </div>
                        <transition name="slide">
                            <div class="chat-block" v-if="ikwilwebsite">
                                <div class="chat-bubble chat-bubble--left">Hoe wil je dat wij contact opnemen?</div>
                                <div class="btn-option" v-if="!mailmij"><button class="btn btn-primary" @click.prevent="belmij = true, orderinfo.contactby = 'Phone'">Bel mij</button></div>
                                <div class="btn-option" v-if="!belmij"><button class="btn btn-primary" @click.prevent="mailmij = true, orderinfo.contactby = 'Email'">Stuur mij een e-mail</button></div>
                            </div>
                        </transition>
                        <transition name="slide">
                            <div class="chat-block" v-if="iktwijfel">
                                <div class="chat-bubble chat-bubble--left">Dat begrijpen wij. Jouw website is een belangrijk onderdeel van je bedrijf! Waar twijfel je aan?</div>
                                <div class="btn-option"><button class="btn btn-primary" @click.prevent="mogelijkheden = true, orderinfo.infoneeded = 'Possibilities'">Aan de mogelijkheden</button></div>
                                <div class="btn-option"><button class="btn btn-primary" @click.prevent="mogelijkheden = true, orderinfo.infoneeded = 'Price'">Aan de prijs</button></div>
                            </div>
                        </transition>
                        <transition name="slide">
                            <div class="chat-block" v-if="mogelijkheden">
                                <div class="chat-bubble chat-bubble--left">Wij informeren je graag over meer. Hoe wil je dat wij contact opnemen?</div>
                                <div class="btn-option" v-if="!mailmij"><button class="btn btn-primary" @click.prevent="belmij = true, orderinfo.contactby = 'Phone'">Bel mij terug</button></div>
                                <div class="btn-option" v-if="!belmij"><button class="btn btn-primary" @click.prevent="mailmij = true, orderinfo.contactby = 'Email'">Stuur mij een e-mail</button></div>
                            </div>
                        </transition>
                        <transition name="slide">
                            <div class="chat-block" v-if="belmij">
                                <div class="chat-bubble chat-bubble--left">Op welk nummer mogen wij jou bellen?</div>
                                <input type="text" id="sale-tel" name="sale-tel" v-model="orderinfo.phonenumber" placeholder="Jouw telefoonnummer" class="form-control mb-2" autofocus/>
                                <div class="btn-option"><button class="btn btn-primary submit-chat-form" @click.prevent="thanks = true, saveOrderInfo()">Bel mij</button></div>
                            </div>
                        </transition>
                        <transition name="slide">
                            <div class="chat-block" v-if="mailmij">
                                <div class="chat-bubble chat-bubble--left">Kunnen wij je mailen op <strong id="usergivenemail">Emailadres?</strong>?</div>
                                <div class="btn-option" v-if="!andermail"><button class="btn btn-primary" @click.prevent="thanks = true, saveOrderInfo()">Ja, graag!</button></div>
                                <div class="btn-option" v-if="!thanks"><button class="btn btn-primary" @click.prevent="andermail = true">Nee, op een ander adres...</button></div>
                            </div>
                        </transition>
                        <transition name="slide">
                            <div class="chat-block" v-if="andermail">
                                <div class="chat-bubble chat-bubble--left">Geef een emailadres op:</div>
                                <input type="text" id="sale-email" name="sale-email" v-model="orderinfo.email" placeholder="Jouw e-mailadres" class="form-control mb-2" autofocus/>
                                <div class="btn-option"><button class="btn btn-primary submit-chat-form" @click.prevent="thanks = true, saveOrderInfo()">Mail mij</button></div>
                            </div>
                        </transition>
                        <transition name="slide">
                            <div class="chat-block" v-if="thanks">
                                <div class="chat-bubble chat-bubble--left">Wij nemen meteen contact met je op! Bedankt voor je vertrouwen in Phabsite! Ga gerust verder met aanpassen.</div>
                                <button class="btn btn-primary sluit-chat" @click.prevent="chatBox = false">Chat sluiten</button>
                            </div>
                        </transition>

                    </form>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    import InlineEditor from '../app/InlineEditor.vue';
    import SocialIcons from './SocialIcons.vue';

    import { userService } from '../../services/user.service.js';
    import { authHeader } from '../../services/auth-header.js';

    import axios from 'axios';

    export default {
        components:{
            InlineEditor,
            SocialIcons
        },
        props:{
            websiteid: String,
            readonly: Boolean,
            creatoreditor: Boolean,
            sitedata: Object
        },
        data: function(){
            return{
                onepager: false,
                editmode: false,
                chatBox: false,
                ikwilwebsite: false,
                iktwijfel: false,
                mogelijkheden: false,
                belmij: false,
                mailmij: false,
                andermail: false,
                thanks: false,
                menupages: '',
                pagetitle: '',
                urlprefix: '',
                orderinfo: {},
                userWebsiteId: JSON.parse(localStorage.getItem('user')).websiteid
            }
        },
        methods: {
            toggleView(){
                this.$emit('clicked')

            },
            saveOrderInfo(){
                const requestOptions = {
                    headers: authHeader()
                }

                const data = {
                    websiteid: this.$route.params.websiteid,
                    content: [this.orderinfo]
                }

                axios.patch(process.env.VUE_APP_ROOT_API+'/settings/buy/', data, requestOptions)
                .then(response => {
                    // some response?
                })
            },
            getPages(belongsto){
                axios.get(process.env.VUE_APP_ROOT_API+'/pages/'+this.websiteid+'/'+belongsto)
                .then(response => {
                    this.menupages = response.data.response
                })
            }
        },
        mounted(){
            if(!this.creatoreditor){
                this.urlprefix = '/'
            } else {
                this.urlprefix = '/creator/'+this.websiteid+'/'
            }
        },
        watch: {
            sitedata: {
                handler(sitedata) {
                    if(this.sitedata.settings[0].use_one_pager){
                        this.getPages('home')
                        this.urlprefix = '#'
                        this.onepager = true
                    } else {
                        this.getPages('nav')
                        if(!this.creatoreditor){
                            this.urlprefix = '/'
                        } else {
                            this.urlprefix = '/creator/'+this.websiteid+'/'
                        }
                    }
                }
            }
        }

    }
</script>